const MiHelper = {};

MiHelper.install = function (Vue, options) {
    const _DH = "dh";
    const _CONSULTATION = "CONSULTATION";
    const _DRESSING = "DRESSING";
    const _EXAMINATION = "EXAMINATION";
    const _WAITING = "WAITING"
    const _STARTED = "Started"
    const _PLANNED = "Planned"
    const _DONE = "Done"

    const STRING_RANK = {
        CONSULTATION: 0,
        DRESSING: 1,
        EXAMINATION: 2,
        WAITING: 3,
        Started: 4,
        Planned: 5,
        Done: 6
    };

    function compareString(a, b) {
        return STRING_RANK[a] - STRING_RANK[b] === 0;
    }


    Vue.mixin({
        methods: {
            isPluginDH(plugin) {
                return (plugin === _DH);
            },

            isDressing(string) {
                return compareString(string, _DRESSING);
            },

            isExamination(string) {
                return compareString(string, _EXAMINATION);
            },

            isConsultation(string) {
                return compareString(string, _CONSULTATION);
            },

            isWaiting(string) {
                return compareString(string, _WAITING);
            },

            isPlanned(string) {
                return compareString(string, _PLANNED);
            },

            isDone(string) {
                return compareString(string, _DONE);
            },

            isStarted(string) {
                return compareString(string, _STARTED);
            }

        }
    });

};

export default MiHelper;